import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { StatusPage } from '@kanda-libs/ks-apply';
import { Button } from '@kanda-libs/ks-design-library';

import JobLayout from 'components/JobLayout';
import { URLS } from 'config';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';
import { selectors } from 'store';

const Success: FunctionComponent = function () {
  const { id } = useSelector(selectors.getPathKey);

  return (
    <ApplyProvider>
      <JobLayout header={<ApplyHeader />} showJobCard={false}>
        <StatusPage title="You have been pre-approved">
          <Button.Text
            id="checkout-aip-success-next"
            label="Next"
            variant="gradient"
            onClick={() => {
              window.location.href = URLS.quote.replace(':id', id || '');
            }}
          />
        </StatusPage>
      </JobLayout>
    </ApplyProvider>
  );
};

export default Success;
